import React from "react";
import { Classifier } from "./util/classifierManager";

interface OrganisationSearchView {
  organisation?: Classifier;
  active?: Classifier;
}

interface ContractSearchView {
  message?: string;
}

const SubviewContext = React.createContext<{
  organisationSearch?: OrganisationSearchView;
  setOrganisationSearch: (organisationSearch?: OrganisationSearchView) => void;
  contractSearch?: ContractSearchView;
  setContractSearch: (contractSearch?: ContractSearchView) => void;
}>(undefined!);

export const SubviewProvider = SubviewContext.Provider;
export const SubviewConsumer = SubviewContext.Consumer;

export default SubviewContext;
